<template>
  <div class="relative inline-flex rounded-full">
    <div
      v-if="user && hasLootpass"
      class="absolute -left-[5%] -top-[5%] z-10 flex size-2/5 items-center justify-center rounded-full bg-depth-0"
    >
      <fa-icon
        :icon="faGem()"
        class="text-warning h-[90%] w-[90%]"
        aria-label="Lootpass Icon"
      />
    </div>
    <img
      v-if="user"
      class="rounded-full w-[inherit] h-[inherit] object-cover"
      :class="{ 'border-gradient-rainbow': hasLootpass }"
      :src="user.avatarUrl"
      :alt="`Profile ${user.username}`"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script lang="ts">
import { faGem } from '@fortawesome/pro-solid-svg-icons';
import { CustomerFlag } from 'gportal-grpc/gportal/api/user/v1/customer_pb';

export default defineComponent({
  props: {
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
  },
  setup() {
    const authStore = useAuthStore();
    const user = computed(() => authStore.user);

    const hasLootpass = computed(() =>
      authStore.hasCustomerFlag(CustomerFlag.LOOT_PASS),
    );

    return { user, hasLootpass };
  },
  methods: {
    faGem() {
      return faGem;
    },
  },
});
</script>
